import { ClipboardCheck } from "iconoir-react";
import React from "react";
import Swal from "sweetalert2";
import { domain } from "../../../../Urls/Services/Api_urls";
import { Loader } from "../../../../Loader/Loader";


export const OrdeBuy = (props) => {
  const tableMeta = props.tableMeta;
  const [loading, setLoading] = React.useState(false);
  const [buttonDisabled, setButtonDisabled] = React.useState(false);

  const createOrder = () => {
    setLoading(true);
    setButtonDisabled(true);

    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${token}`);
    myHeaders.append("Content-Type", "application/json");

    const idp = tableMeta.id;

    var raw = JSON.stringify({
      id: idp,
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    Swal.fire({
      title: "Crear orden de trabajo",
      // text: tableMeta.rowData[3],
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, registrar venta",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.isConfirmed) {
        fetch(domain + "/portal/" + idp + "/buyNewCustomer/", requestOptions)
          .then(async function (response) {
            if (response.status === 200) {
              setLoading(false); // probar
              Swal.fire(
                "Orden de trabajo registrada correctamente",
                "Verifica en SIGT",
                "success"
              ).finally(() => {
                window.location.reload();
              });
            } else {
              if (response.status === 400) {
                try {
                    const { msg = {} } = await response.json();
                    const errors = typeof msg === 'string' ? { error: msg } : msg;
                    
                    Swal.fire({
                        icon: "error",
                        title: "Error",
                        html: `
                            <div>
                                ${Object.entries(errors).map(([field, error]) => `
                                    <div><b>${field}:</b> ${Array.isArray(error) ? error.join('<br>') : error}</div>
                                `).join('')}
                            </div>
                        `,
                    });
                } finally {
                    setButtonDisabled(false);
                }
              }
            }
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "error",
              text: "Ocurrió un error",
            });
            setButtonDisabled(false);
          })
          .finally(() => {
            setLoading(false);
          });
      } else {
        setLoading(false);
        setButtonDisabled(false);
      }
    });
  };

  const [groups, setGroups] = React.useState(null);
  const [token, setToken] = React.useState(null);

  React.useEffect(() => {
    setGroups(window.sessionStorage.getItem("groups"));
    setToken(window.sessionStorage.getItem("token"));
  }, []);

  const allowedStatus = new Set([
    "Orden creada",
    "Rechazado",
    "Por Firmar",
    "Recibida",
    "Orden en Progreso",
    
  ]);

  if (loading) {
    return <Loader />;
  }

  if (!allowedStatus.has(tableMeta.is_actived)) {
    return (
      <>
        <button className="p-1 cursor-pointer bg-orange-500 hover:bg-orange-600 text-white rounded-md "
          onClick={createOrder}
          disabled={buttonDisabled}
          title="Crear orden de trabajo"
        >
          <ClipboardCheck />
        </button>
      </>
    );
  } else return null;
};